module.exports = __webpack_public_path__ + "static/media/wenghei.9c132d04.jpg";